/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  LibWalletRichErrors1,
  LibWalletRichErrors1Interface,
} from "../LibWalletRichErrors1";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "wallet",
        type: "address",
      },
      {
        internalType: "address",
        name: "callTarget",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "callData",
        type: "bytes",
      },
      {
        internalType: "uint256",
        name: "callValue",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "errorData",
        type: "bytes",
      },
    ],
    name: "WalletExecuteCallFailedError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "wallet",
        type: "address",
      },
      {
        internalType: "address",
        name: "callTarget",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "callData",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "errorData",
        type: "bytes",
      },
    ],
    name: "WalletExecuteDelegateCallFailedError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
];

export class LibWalletRichErrors1__factory {
  static readonly abi = _abi;
  static createInterface(): LibWalletRichErrors1Interface {
    return new utils.Interface(_abi) as LibWalletRichErrors1Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): LibWalletRichErrors1 {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as LibWalletRichErrors1;
  }
}
